import { useState, useEffect } from "react";
import certificate from "../../assets/images/Customer/certificate.svg";
import st1 from "../../assets/images/Customer/st1.webp";
import st1pc from "../../assets/images/Customer/st1pc.webp";
import st2 from "../../assets/images/Customer/st2.webp";
import st2pc from "../../assets/images/Customer/st2pc.webp";
import st3 from "../../assets/images/Customer/st3.webp";
// import st3pc from "../../assets/images/Customer/st3pc.webp";
import st4 from "../../assets/images/Customer/st4.webp";
import st4pc from "../../assets/images/Customer/st4pc.webp";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import sto_pc from "../../assets/images/Customer/sto_pc.webp";
import sto_mobi from "../../assets/images/Customer/sto_mobi.webp";

const stories = [
  {
    id: 1,
    images: { mobile: st1, desktop: st1pc },
    text: (
      <div className="w-full flex flex-col gap-3">
        <div>
          <p className="text-white">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            cursus nulla vitae massa gravida, id fringilla arcu rhoncus.
          </p>
        </div>
        <div>
          <p className="text-white">Ali Center - CEO Mrs. Linh Pham</p>
        </div>
        <div>
          <p className="text-white">Xem chi tiết</p>
        </div>
      </div>
    ),
  },
  {
    id: 2,
    images: { mobile: st2, desktop: st2pc },
    text: (
      <div className="w-full flex flex-col gap-3">
        <div>
          <p className="text-white">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            cursus nulla vitae massa gravida, id fringilla arcu rhoncus.
          </p>
        </div>
        <div>
          <p className="text-white">Ali Center - CEO Mrs. Hung</p>
        </div>
        <div>
          <p className="text-white">Xem chi tiết</p>
        </div>
      </div>
    ),
  },
  {
    id: 3,
    images: { mobile: st3, desktop: "" },
    text: (
      <div className="w-full flex flex-col gap-3">
        <div>
          <p className="text-white">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            cursus nulla vitae massa gravida, id fringilla arcu rhoncus.
          </p>
        </div>
        <div>
          <p className="text-white">Ali Center - CEO Mrs. Lan</p>
        </div>
        <div>
          <p className="text-white">Xem chi tiết</p>
        </div>
      </div>
    ),
  },
  {
    id: 4,
    images: { mobile: st4, desktop: st4pc },
    text: (
      <div className="w-full flex flex-col gap-3">
        <div>
          <p className="text-white">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            cursus nulla vitae massa gravida, id fringilla arcu rhoncus.
          </p>
        </div>
        <div>
          <p className="text-white">Ali Center - CEO Mrs. Nam</p>
        </div>
        <div>
          <p className="text-white">Xem chi tiết</p>
        </div>
      </div>
    ),
  },
];

export default function CustomerStory() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % stories.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? stories.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % stories.length);
  };

  return (
    <div className="w-full">
      <div className="w-full flex flex-col gap-3 container mx-auto px-[24px] py-[16px]">
        <div className="w-full  flex items-center gap-3 rounded-[100px] bg-[#E6ECFA] p-2 justify-center">
          <div className="w-16 h-12 md:w-12 bg-[#053CC8] rounded-full flex items-center justify-center">
            <img src={certificate} alt="cer" />
          </div>
          <div>
            <p>Câu chuyện thành công từ các đối tác của chúng tôi</p>
          </div>
        </div>

        <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4 relative">
          <div className="w-full flex items-center gap-2 md:flex-col md:gap-2">
            {stories.slice(0, 2).map((story, index) => (
              <div
                key={story.id}
                onClick={() => setActiveIndex(index)}
                className={`cursor-pointer ${
                  activeIndex === index
                    ? "border-2 border-blue-500 rounded-[16px]"
                    : ""
                }`}
              >
                <img
                  src={story.images.mobile}
                  alt="m1"
                  className="block md:hidden w-full h-auto object-cover"
                />
                <img
                  src={story.images.desktop}
                  alt="m2"
                  className="hidden md:block w-full h-auto object-cover"
                />
              </div>
            ))}
          </div>

          <div
            className="w-full rounded-[16px] px-[24px] py-[16px] bg-center bg-cover bg-no-repeat flex items-center justify-center text-white font-bold"
            style={{
              backgroundImage: `url(${
                window.innerWidth < 768 ? sto_mobi : sto_pc
              })`,
              color: '#fff',
            }}
          >
            <div className="w-full text-white">{stories[activeIndex].text}</div>
          </div>

          <div className="w-full flex items-center gap-2 md:flex-col md:gap-2">
            {stories.slice(2).map((story, index) => (
              <div
                key={story.id}
                onClick={() => setActiveIndex(index + 2)}
                className={`cursor-pointer ${
                  activeIndex === index + 2
                    ? "border-2 border-blue-500 rounded-[16px]"
                    : ""
                }`}
              >
                <img
                  src={story.images.mobile}
                  alt="m3"
                  className="block md:hidden w-full h-auto object-cover"
                />
                <img
                  src={story.images.desktop}
                  alt="m4"
                  className="hidden md:block w-full h-auto object-cover"
                />
              </div>
            ))}
          </div>
          <div>
            <div className="block md:hidden">
              <div className="w-full flex items-center justify-between">
                <FaChevronLeft
                  onClick={handlePrev}
                  className="cursor-pointer"
                />

                <FaChevronRight
                  onClick={handleNext}
                  className="cursor-pointer"
                />
              </div>
            </div>

            <div className="hidden md:block">
              <div className="w-full flex items-center justify-between md:rotate-90 md:w-80 absolute -right-28 bottom-[50%]">
                <FaChevronLeft
                  onClick={handlePrev}
                  className="cursor-pointer"
                />
                <FaChevronRight
                  onClick={handleNext}
                  className="cursor-pointer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
